import { useEffect, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { ArrowUp } from "lucide-react";
import { useLang } from "@/context/LangContext";
import { SEARCH_UI as UI } from "@/data/quickSearchI18n";

// Floating "back to top" button; appears after scrolling past ~1.5 screens, sits above the bottom nav on phones.
export const ScrollToTop = () => {
  const { tc } = useLang();
  const [show, setShow] = useState(false);
  useEffect(() => {
    const onScroll = () => setShow(window.scrollY > Math.max(600, window.innerHeight * 1.2));
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);
  return (
    <AnimatePresence>
      {show && (
        <motion.button type="button" initial={{ opacity: 0, scale: 0.8, y: 8 }} animate={{ opacity: 1, scale: 1, y: 0 }} exit={{ opacity: 0, scale: 0.8, y: 8 }}
          onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })} aria-label={tc(UI.backToTop)} title={tc(UI.backToTop)} data-testid="scroll-to-top"
          className="fixed end-4 z-30 flex h-11 w-11 items-center justify-center rounded-full glass border border-white/50 text-primary shadow-[0_8px_30px_rgb(0,0,0,0.12)] active:scale-95 transition-transform scroll-top-safe">
          <ArrowUp className="h-5 w-5" />
        </motion.button>
      )}
    </AnimatePresence>
  );
};
